import { render, staticRenderFns } from "./ContactTypesActions.partial.vue?vue&type=template&id=72018ba1&scoped=true"
import script from "./ContactTypesActions.partial.vue?vue&type=script&lang=js"
export * from "./ContactTypesActions.partial.vue?vue&type=script&lang=js"
import style0 from "./ContactTypesActions.partial.vue?vue&type=style&index=0&id=72018ba1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72018ba1",
  null
  
)

export default component.exports